import { render, staticRenderFns } from "./InventoryCalendar.vue?vue&type=template&id=c35b9158&scoped=true&"
import script from "./InventoryCalendar.vue?vue&type=script&lang=js&"
export * from "./InventoryCalendar.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCalendar.vue?vue&type=style&index=0&id=c35b9158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35b9158",
  null
  
)

export default component.exports